import React, { PureComponent } from 'react'
import { StyleSheet } from 'react-native';
import Modal from '@dbk/ui-modal';
import Text from '@dbk/ui-text';
import Button from '@dbk/ui-buttons';
import styles from './payment-confirmation.styles';
import { TextArea } from '@dbk/ui-forms';

class PaymentRejectModal extends PureComponent  {
  
    constructor(props){
        super(props)
        this.state = {
            rejectReason: ''
        }
    }
    componentDidMount(){
        if(document.querySelector('button.rejectButton')){
            document.querySelector('button.rejectButton').focus();
        }
    }
    
    handleRejectReasonText = (text) => {
        this.setState({rejectReason: text.target.value});
    }
    render() {
        const { messages, onCancel, onRejectDone, isLoading}  = this.props
        return (
            <Modal
                isActive
                disableOutsideClick
                className="modal-payment-reject"
                onClose={()=>onCancel()}
                header={messages['app.payments.multisig.rejectDialogTitle']}
                content={
                <div className='reject-dialog-header'>  
                    <p tabIndex={0}>{messages['app.payments.multisig.rejectDialogHeader']}</p>    
                    <div>
                        <Text secondary className='reject-dialog-subheader'>
                            <label > {messages['app.payments.multisig.rejectDialogSubheader']}</label>
                            <span>{this.state.rejectReason.length} / 140</span>
                        </Text>
                        <TextArea
                            fullWidth
                            secondary
                            numberOfLines={3}
                            rows={3}
                            className='reject-reason-textarea'
                            maxlength={140}
                            size="medium"
                            onChange={(text) => this.handleRejectReasonText(text)}
                            multiline
                            placeholder={messages['app.payments.multisig.rejectDialogPlaceholder']}
                            selectTextOnFocus={false}
                            caretHidden={false}
                            contextMenuHidden={false}
                            value={this.state.rejectReason}
                        />
                    </div>
                    <div>
                        <div style={StyleSheet.flatten(styles.paymentBtnBlockReject)}>
                            <div className="payment-btn" >
                            <Button
                                tertiary
                                fullWidth
                                size="large"
                                onPress={onCancel} >
                                {messages['app.payments.summary.cancel']}
                            </Button>
                            </div>
                            <div className="payment-btn" style={{marginRight:'0px'}}>
                            <Button
                                className="rejectButton"
                                fullWidth
                                size="large"
                                loading={isLoading}
                                onPress={()=>{onRejectDone(this.state.rejectReason);}} >
                            {messages['app.payments.multisig.reject']}
                            </Button>
                            </div>
                        </div>
                        </div>
                </div> 
                }
                />
            )
        }

}

export default PaymentRejectModal